export default {
  general: {
    save: 'บันทึก',
    autosaved: 'บันทึกอัตโนมัติแล้ว',
    back_to: 'กลับไปยัง',
    by: 'โดย',
    chat: 'การพูดคุย',
    completed: 'สำเร็จแล้ว',
    canceled: 'ยกเลิกแล้ว',
    component: 'ส่วนประกอบ',
    confirm: 'ยืนยัน',
    course: 'คอร์สเรียน',
    date: 'วันที่',
    details: 'รายละเอียด',
    empty: 'ไม่มีข้อมูล',
    enrolled: 'ลงเรียนสำเร็จ',
    free: 'ฟรี',
    graph: 'กราฟ',
    loading: 'กำลังโหลด…',
    lesson: 'บทเรียน',
    lessons: 'บทเรียน',
    live_assessment: 'การประเมินผลแบบวีดีโอถ่ายทอดสด',
    live_event: 'วีดีโอถ่ายทอดสด',
    no: 'ไม่',
    of: 'จาก',
    or: 'หรือ',
    organization: 'องค์กร',
    page: 'หน้า',
    pages: 'หน้า',
    personal: 'ส่วนตัว',
    poll: 'แบบสำรวจ',
    rating: 'ให้คะแนน',
    reset: 'ล้างข้อมูล',
    signin: 'เข้าสู่ระบบ',
    signup: 'สมัครใช้งาน',
    soon: 'เร็วๆ นี้',
    type: 'พิมพ์',
    uploading: 'กำลังอัพโหลด',
    yes: 'ใช่',
    something_went_wrong: 'มีบางอย่างผิดพลาด',
    view_all: 'ดูทั้งหมด',
    upload_successful: 'อัพโหลดสำเร็จ',
    upload_successful_message:
      'ไฟล์ของคุณอัพโหลดแล้ว ตอนนี้กำลังประมวลผล อาจใช้เวลาเล็กน้อย',
    check_email_upload_successful:
      'กรุณา<0>เช็คอีเมลของคุณ</0> สำหรับ <1>รายงาน</1>การอัพโหลดรายชื่อผู้ใช้งาน',
    is_private: 'ความเป็นส่วนตัว'
  },

  account: {
    title: 'บัญชี',
    subtitle: 'จัดการการตั้งค่าและข้อมูลบัญชีของคุณ',
    saved: 'เปลี่ยนแปลงข้อมูลบัญชีเรียบร้อยแล้ว'
  },

  assessments: {
    title: 'การประเมินผลแบบวีดีโอถ่ายทอดสด',
    subtitle: 'สร้างการประเมินผลแบบวีดีโอนถ่ายทอดสด',
    finished: 'การประเมินผลแบบวีดีโอนถ่ายทอดสดเสร็จสิ้นแล้ว',
    countdown: 'การประเมินผลแบบวีดีโอถ่ายทอดสดจะเริ่มใน ',
    create: 'สร้างการประเมินผลแบบวีดีโอถ่ายทอดสด',
    list_title: 'การประเมินผลแบบวีดีโอนถ่ายทอดสดของคุณ',
    delete_warning: 'คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้',
    details_title: 'เพิ่มรายละเอียดการประเมินผลสด',
    details_subtitle:
      'กรุณาตั้งชื่อการประเมินผลแบบวีดีโอถ่ายทอดสดนี้ พร้อมคำบรรยายสิ่งที่ผู้ร่วมชมจะได้รับจากการประเมินผลนี้',
    disclaimer: `ฉันรับประกันว่าการบันทึกการประเมินผลแบบวีดีโอถ่ายทอดนี้จะไม่:
    - ไม่ละเมิดสิทธิ์ของบุคคลที่สาม
    -  ไม่มีเนื้อหาที่ผิดกฎหมายใด ๆ รวมถึงเนื้อหาที่หมิ่นประมาทลามกอนาจารลามกอนาจาร รุนแรงหยาบคายดูถูกคุกคามหรือเลือกปฏิบัติแม้กระทั่งแฝงด้วยเครื่องหมายดอกจัน
    - ไม่มีการโจมตีบุคคลอื่นเป็นการส่วนตัว
    - ไม่มีการแอบอ้างเป็นบุคคลอื่นบุคคลสาธารณะหรือคนดัง
    - ไม่มีการบันทึกหรือข้อมูลส่วนบุคคลใด ๆ ของบุคคลใด ๆ โดยไม่ได้รับความยินยอมจากบุคคลดังกล่าวและไม่ละเมิดกฎข้อบังคับในการคุ้มครองข้อมูลใด ๆ ในส่วนใดของโลก
    - ไม่มีการชักชวนทางการค้าหรือ "สแปม" "ในรูปแบบใด ๆ'`,

    // newlyadded
    assessment_details: 'รายละเอียดการประเมิน',
    assessment_settings: 'การตั้งค่าการประเมิน'
  },

  buildersettings: {
    title: 'การตั้งค่าการเผยแพร่',
    subtitle:
      'เพิ่มการตั้งค่าอีเว้นท์ เลือกคนที่สามารถมองเห็นและมีส่วนร่วมกับอีเว้นท์ของคุณ'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'เพิ่ม',
    add_page: 'เพิ่มหน้า',
    add_lesson: 'เพิ่มบทเรียน',
    add_answer: 'เพิ่มคำตอบใหม่',
    add_group: 'เพิ่มกรุ๊ป',
    add_organization: 'เพิ่มองค์กร',
    add_question: 'เพิ่มคำถาม',
    add_quiz: 'เพิ่มแบบสอบถาม',
    add_users: 'เพิ่มผู้ใช้งานหลายคน',
    back: 'ย้อนกลับ',
    back_to_course: 'กลับสู่หน้ารวมคอร์ส ',
    back_to_lesson: 'กลับสู่หน้ารวมบทเรียน',
    back_to_media: 'กลับสู่คลังภาพ',
    back_to_details: 'กลับสู่รายละเอียด',
    cancel: 'ยกเลิก',
    clear: 'ล้างข้อมูล',
    close: 'ปิด',
    clone: 'สร้างสำเนา',
    close_lesson: 'ปิดบทเรียน',
    clone_course: 'สร้างสำเนาคอร์ส',
    confirm: 'ยืนยัน',
    create: 'สร้าง',
    download: 'ดาวโหลด',
    download_mass_user_tamplate: 'ดาวน์โหลดเทมเพลต',
    add_mass_users: 'เพิ่มผู้ใช้หลายคน',
    upload_excel_list: 'อัพโหลดไฟล์ excel',
    delete: 'ลบสื่อ',
    edit: 'แก้ไข',
    edit_course: 'แก้ไขคอร์สเรียน',
    enroll: 'ลงเรียน',
    finish: 'เสร็จสิ้น',
    upload_image: 'อัพโหลดรูปภาพ',
    upload_image_video: 'อัพโหลดรูปภาพหรือวีดีโอ',
    select_media_library: 'เลือกรูปจากคลังรูป',
    make_public: 'เผยแพร่สู่สาธารณะ',
    make_private: 'ตั้งค่าความเป็นส่วนตัว',
    make_org: 'ทำให้เป็นองค์กร',
    media: 'คลังรูปภาพ',
    my_theme: 'ธีมของฉัน',
    next: 'ถัดไป',
    next_lesson: 'บทเรียนถัดไป',
    next_step: 'ขั้นตอนต่อไป',
    previous_step: 'ขั้นตอนก่อนหน้า',
    publish: 'เผยแพร่',
    publish_assessment: 'เผยแพร่การประเมินผลแบบวีดีโอถ่ายทอดสด',
    publish_course: 'เผยแพร่คอร์สของคุณ',
    publish_event: 'เผยแพร่วีดีโอถ่ายทอดสดของคุณ',
    reset: 'กลับสู่ค่าเริ่มต้น',
    reset_elements: 'กลับสู่ค่าเริ่มต้นขององค์ประกอบ',
    save: 'บันทึก',
    creating: 'กำลังสร้าง',
    updating: 'กำลังอัพโหลด',
    saved: 'บันทึกแล้ว',
    save_for_later: 'บันทึกสำหรับภายหลัง',
    save_settings: 'บันทึกการตั้งค่า',
    select_files: 'เลือกไฟล์',
    select_theme: 'เลือกธีม',
    start_lesson: 'เริ่มบทเรียน',
    update: 'อัพโหลด',
    upload: 'อัพโหลด',
    upload_audio: 'อัพโหลดเสียง',
    upload_photo: 'อัพโหลดรูปโปรไฟล์ ',
    upload_video: 'อัพโหลดวีดีโอ',
    enrolled: 'ลงเรียน',
    unenroll: 'ยกเลิกการลงเรียน',
    from_library: 'คลังรูปภาพ',
    remove: 'ลบ',
    removed: 'ลบสำเร็จ',
    start_broadcast: 'เริ่มการถ่ายทอดสด',
    end_broadcast: 'จบการถ่ายทอดสด',
    camera: 'กล้อง',
    screen: 'หน้าจอ',
    screen_with_camera: 'แสดงหน้าจอคอมพร้อมกล้อง',

    // newlyadded
    insert: 'แทรก',
    inserting: 'การแทรก'
  },

  card: {
    quick_add: 'การเพิ่มแบบรวดเร็ว',
    add: 'เพิ่ม',
    clone: 'สร้างสำเนา',
    completed: 'บทเรียนสำเร็จแล้ว'
  },

  course: {
    upcoming_course: 'คอร์สใหม่เร็วๆ นี้',
    unPublishEvent: 'วีดีโอถ่ายทอดสดที่ยังไม่ได้เผยแพร่',
    unPublishAssessment: 'การประเมินผลแบบถ่ายทอดสดที่ยังไม่ได้เผยแพร่',
    pastCourse: 'หลักสูตรการเรียน',
    upcoming: 'วีดีโอถ่ายทอดสดใหม่เร็วๆ นี้',
    pastEvent: 'วีดีโอถ่ายทอดสดที่ผ่านมาแล้ว',
    pastAssessment: 'การประเมินผลแบบวีดีโอถ่ายทอดสดที่ผ่านมาแล้ว',
    upcomingAssessment: 'การประเมินผลแบบวีดีโอถ่ายทอดสดใหม่ เร็วๆ นี้ ',
    created: 'วันที่สร้าง:',
    assignees: 'ผู้รับสิทธิ',
    organisations:
      ' {{ organizations }} องค์กร, <2> {{ users }} ผู้ใช้งาน</2>',
    event_date: 'วันที่ถ่ายทอดสด <1> {{ date }} </1>',
    delete_warning: 'คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้',
    clonning_no_lesson:
      'เลือกเพิ่มบทเรียนอย่างน้อยหนึ่งบทเรียนเพื่อทำการสร้างสำเนาคอร์สเรียนนี้.',
    clone_warning: 'คุณแน่ใจหรือว่าต้องการสร้างสำเนา',
    clone_success: 'อยู่ระหว่างการสร้างสำเนา',
    disclaimer: `ฉันรับประกันว่าคอร์สเรียนของฉันจะไม่:
    - ไม่ละเมิดสิทธิ์ของบุคคลที่สาม
    -  ไม่มีเนื้อหาที่ผิดกฎหมายใด ๆ รวมถึงเนื้อหาที่หมิ่นประมาทลามกอนาจารลามกอนาจาร รุนแรงหยาบคายดูถูกคุกคามหรือเลือกปฏิบัติแม้กระทั่งแฝงด้วยเครื่องหมายดอกจัน
    - ไม่มีการโจมตีบุคคลอื่นเป็นการส่วนตัว
    - ไม่มีการแอบอ้างเป็นบุคคลอื่นบุคคลสาธารณะหรือคนดัง
    - ไม่มีการบันทึกหรือข้อมูลส่วนบุคคลใด ๆ ของบุคคลใด ๆ โดยไม่ได้รับความยินยอมจากบุคคลดังกล่าวและไม่ละเมิดกฎข้อบังคับในการคุ้มครองข้อมูลใด ๆ ในส่วนใดของโลก
    - ไม่มีการชักชวนทางการค้าหรือ "สแปม" "ในรูปแบบใด ๆ'`
  },

  coursecreate: {
    dropzone_text: 'ใส่รูปภาพ',
    sidebar_text: 'เลือกธีม <1/> บทเรียน <3/> ของคุณ',
    delete_warning: 'คุณแน่ใจหรือว่าต้องการลบบทเรียนนี้'
  },

  coursepage: {
    quizview_loading: 'กำลังตรวจสอบคำตอบ กรุณารอสักครู่',
    quizview_answer: 'คำตอบของคุณ'
  },

  coursequiz: {
    title: 'คำถามทั้งหมดในทุกบทเรียน'
  },

  dashboard: {
    tooltip_title: 'ไม่ต้องแสดงวีดีโอนี้อีก',
    page_title: 'สถิติคอร์สเรียนของคุณ',
    page_subtitle: 'สถานะของคอร์สเรียนที่คุณสร้าง',
    profile_add_info:
      'เพิ่มข้อมูลของคุณ <1>{{uncompletedText}}</1> เพื่อให้โปรไฟล์ของคุณสมบูรณ์.',
    profile_build:
      'สร้างโปรไฟล์ของคุณ<1>ที่นี่</1>,แจ้งให้เราทราบความสนใจพิเศษหรือความสามารถของคุณ',
    profile_title: 'โปรไฟล์มีความแข็งแรง',
    more_details: 'รายละเอียดเพิ่มเติม'
  },

  errors: {
    answer: 'กรุณาใส่คำตอบ',
    answer_correct: 'เลือกคำตอบที่ถูกต้อง',
    code: 'กรุณาใส่รหัสโคดของคุณ',
    criterion: 'กรุณาใส่เกณฑ์',
    duration: 'กรุณาใส่ระยะเวลา',
    element: 'กรุณาใส่องค์ประกอบอื่นๆ',
    email: 'กรุณาใส่อีเมลของคุณ',
    email_invalid: 'อีเมลไม่ถูกต้อง',
    feedback_correct: 'กรุณาใส่คำตอบที่ถูกต้อง',
    feedback_incorrect: 'กรุณาใส่คำตอบที่ไม่ถูกต้อง',
    host: 'กรุณาใส่ผู้ที่จะทำการถ่ายทอดสด',
    host_assessment: ' กรุณาใส่ผู้ที่จะทำการประเมินผลแบบวีดีโอถ่ายทอดสด',
    image: 'กรุณาอัพโหลดรูปภาพ',
    location: 'กรุณาใส่สถานที่ของคุณ',
    live_location: 'กรุณาเลือกสถานที่ที่คุณจะทำวีดีโอถ่ายทอดสด',
    limit: ' กรุณาใส่จำนวนนาทีที่คุณต้องการทำการถ่ายทอดสด',
    min_3char: 'อย่างน้อยสามตัวอักษร',
    number: 'กรุณาใส่ตัวเลขที่ถูกต้อง',
    host_email_require: ` จำเป็นต้องใส่อีเมลผู้จะทำการถ่ายทอดสด`,
    attendee_email_require: ` จำเป็นต้องใส่อีเมลผู้เข้าร่วมการถ่ายทอดสด`,
    name: 'กรุณาใส่ชื่อของคุณ',
    not_found_course: 'ไม่พบคอร์สนี้',
    not_found_event: 'ไม่พบอีเว้นท์นี้',
    not_found_assessment: 'ไม่พบการประเมินผลโดยวีดีโอนี้',
    password: 'กรุณาใส่รหัสผ่านของคุณ',
    password_digit: 'อย่างน้อยตัวเลขหนึ่งตัว',
    password_short: 'รหัสผ่านสั้นเกินไป อย่างน้อยควรมี 10 ตัวอักษร',
    password_special: 'อย่างน้อยควรมีสัญลักษณ์พิเศษหนึ่งตัว',
    password_uppercase: 'อย่างน้องควรมีตัวพิมพ์ใหญ่หนึ่งตัว',
    password_lowercase: 'อย่างน้อยควรมีตัวพิมพ์เล็กหนึ่งตัว ',
    phone: 'กรุณาใส่เบอร์โทรศัพท์ของคุณ',
    phone_invalid: 'ไม่พบหมายเลขโทรศัพท์นี้',
    position: 'กรุณาใส่ตำแหน่งของคุณ',
    question: 'กรุณาใส่คำถาม',
    start_date: ' กรุณาระบุวันและเวลาที่จะเริ่ม',
    tag: 'กรุณาเลือก tag',
    topics: 'กรุณาเลือกอย่างน้อยหนึ่งหัวข้อ.',
    live_topics: 'กรุณาเพิ่มหัวข้อ',
    title: 'กรุณาใส่หัวเรื่องหรือชื่อเรื่อง',
    title_assessment: 'กรุณาใส่ชื่อการประเมินผลโดยวีดีโอถ่ายทอดสด',
    title_course: 'กรุณาใส่ชื่อคอร์ส',
    title_empty: 'หัวเรื่องไม่สามารถเว้นว่างได้',
    title_event: 'กรุณาใส่ชื่ออีเว้นท์',
    title_lesson: 'กรุณาใส่ชื่อบทเรียน',
    title_quiz: 'กรุณาใส่ชื่อของชุดคำถาม',
    username: 'กรุณาใส่บัญชีผู้ใช้งานของคุณ',
    upload_error: 'ผิดพลาด ไฟล์ของคุณผิดประเภท',
    upload_more_than_10: 'คุณสามารถอัพโหลดรูปภาพพร้อมกันมากสุดได้ 10 ไฟล์',
    topics_max: 'กรุณาเพิ่มหัวข้อสูงสุดได้ 3 หัวข้อ',
    upload_excel: 'กรุณาตรวจสอบไฟล์ที่คุณอัพโหลดถูกต้องหรือไม่',
    title_excel: 'เกิดข้อผิดพลาดในการอัพโหลดแบบ',
    file_size_exceed: 'ขนาดของไฟล์เกินข้อกำหนด',
    subtitle_excel:
      'กรุณาตรวจสอบว่าคุณใช้แบบของเราและใส่ข้อมูลถูกต้องตามแถวและหัวข้อ',
    select_broadcast_option: ' กรุณาเลือกรูปแบบที่คุณต้องการทำการถ่ายทอดสด',
    multi_hosts_number_error:
      'จำนวนของผู้ที่จะทำการถ่ายทอดสดไม่สามารถเกินกว่าที่ได้ระบุไว้ในรายการการถ่ายทอดสด',
    conference_people_number_error: ` จำนวนของผู้ร่วมชมไม่สามารถเกินกว่าที่ได้ระบุไว้ในรายการการถ่ายทอดสด`,
    select_max_host: 'กรุณาเลือกอย่างน้อยหนึ่งคนสำหรับคนที่จะทำการถ่ายทอดสด',
    select_max_conference: 'เลือกอย่างน้อยหนึ่งคนสำหรับผู้ที่จะเข้าร่วมรายการการถ่ายทอดสด',
    stream_stop_error: 'วีดีโอถ่ายทอดสดหยุดกะทันหัน',
    unsecure_context:
      'ข้อผิดพลาดร้ายแรง: เบราเซอร์ไม่สามารถเข้าถึงกล้องและไมโครโฟนเนื่องจากบริบทที่ไม่ปลอดภัย กรุณาติดตั้ง SSL และเข้าถึงผ่าน https',
    ws_not_supported: 'ข้อผิดพลาดร้ายแรง: ไม่รองรับ WebSocket ในเบราเซอร์นี้',

    // newlyadded
    no_org: 'เลือกอย่างน้อย 1 องค์กรเพื่อดำเนินการต่อ',
    no_org_group: 'เลือกกลุ่มองค์กรอย่างน้อย 1 กลุ่มเพื่อดำเนินการต่อ'
  },

  events: {
    title: ' เพิ่มรายละเอียดของวีดีโอถ่ายทอดสด',
    change_host: 'เปลี่ยนผู้ทำการถ่ายทอดสด',
    finished: 'วีดีโอถ่ายทอดสดเสร็จสิ้น',
    countdown: 'วีดีโอถ่ายทอดสดจะเริ่มถ่ายทอดสดใน',
    subtitle:
      ' ตั้งชื่อวีดีโอถ่ายทอดสดนี้และบอกให้ผู้ชมรู้ว่าเขาจะได้เรียนรู้อะไรจากการถ่ายทอดสดนี้',
    poll_disabled: 'แบบสำรวจความคิดเห็นไม่สามารถใช้ได้ในวีดีโอถ่ายทอดสดนี้',
    disclaimer: `ฉันรับประกันว่าวีดีโอถ่ายทดสดที่ได้บันทึกจะไม่:
    - ไม่ละเมิดสิทธิ์ของบุคคลที่สาม
    -  ไม่มีเนื้อหาที่ผิดกฎหมายใด ๆ รวมถึงเนื้อหาที่หมิ่นประมาทลามกอนาจารลามกอนาจาร รุนแรงหยาบคายดูถูกคุกคามหรือเลือกปฏิบัติแม้กระทั่งแฝงด้วยเครื่องหมายดอกจัน
    - ไม่มีการโจมตีบุคคลอื่นเป็นการส่วนตัว
    - ไม่มีการแอบอ้างเป็นบุคคลอื่นบุคคลสาธารณะหรือคนดัง
    - ไม่มีการบันทึกหรือข้อมูลส่วนบุคคลใด ๆ ของบุคคลใด ๆ โดยไม่ได้รับความยินยอมจากบุคคลดังกล่าวและไม่ละเมิดกฎข้อบังคับในการคุ้มครองข้อมูลใด ๆ ในส่วนใดของโลก
    - ไม่มีการชักชวนทางการค้าหรือ "สแปม" "ในรูปแบบใด ๆ'`,
    prompt_message:
      'ออกจากหน้านี้จะให้รายการที่คุณสร้างอยู่สิ้นสุดลง คุณแน่ใจหรือว่าต้องการจะออกจากหน้านี้',
    duration_exceed_message:
      'เวลาถ่ายทอดสดของคุณเกินเวลาที่คุณสามารถทำได้ โปรแกรมกำลังจะหยุดการถ่ายทอดสด',
    before_schedule_message:
      'คุณกำลังจะเริ่มการถ่ายทอดสดก่อนเวลา โปรดทราบว่าถ้าคุณกดหยุด การถ่ายทอดสดจะสิ้นสุดทันที ',
    browser_unsupportive_message:
      'เบราว์เซอร์ของคุณไม่รองรับการแชร์หน้าจอ คุณสามารถตรวจสอบเบราว์เซอร์ที่รองรับได้ในลิ้งนี้ ',
    cancel_switch_host_message:
      'ผู้ที่จะทำการถ่ายทอดสดไม่ว่างขณะนี้ โดยคุณจะเป็นผู้ดำเนินการถ่ายทอดสดต่อไป',
    coaching_prompt_message:
      'คุณไม่สามารถออกจากหน้านี้ได้จนว่าการถ่ายทอดสดจะจบลง',
    event_modal_warn: 'คุณต้องการออกจากการถ่ายทอดสดนี้ใช้ใหม?',
    confirm_message: 'รายการถ่ายทอดสดของคุณจะจบลงเมื่อคุณกดที่ปุ่มตกลง',
    screen_share_denied: 'ปฏิเสธที่จะแชร์หน้าจอของคุณ',
    media_not_found:
      'ไม่พบกล้องหรือไมค์ หรืออุปกรณ์ของคุณไม่ยินยอมให้ใช้งาน',
    media_not_access:
      ' กล้องหรือไมค์ถูกใช้งานอยู่ในโปรแกรมอื่นที่ไม่อนุญาตให้ใช้งาน',
    constraint_error:
      'ไม่พบอุปกรณ์ที่เหมาะกับข้อจำกัดด้านวิดีโอและเสียงของคุณ คุณสามารถเปลี่ยนข้อจำกัดของวิดีโอและเสียงได้',
    media_access_denied: 'คุณยังไม่ได้ยินยอมให้ใช้งานกล้องและไมค์'
  },

  filters: {
    days7: '7 วันที่ผ่านมา',
    days15: '15 วันที่ผ่านมา',
    days30: '30 วันที่ผ่านมา',
    days365: '365 วันที่ผ่านมา',
    date: 'วันที่สร้าง',
    relevance: 'ที่เกี่ยวข้อง',
    popularity: 'ที่ได้รับความนิยม',
    name: 'ชื่อ',
    group: 'กรุ๊ป',
    Newest_to_Oldest: 'ใหม่สุดถึงเก่าสุด',
    Oldest_to_Newest: 'เก่าสุดถึงใหม่สุด',
    A_Z: 'A to Z',
    Z_A: 'Z to A'
  },

  helpers: {
    password:
      'เพื่อความปลอดภัยของบัญชีของคุณเราต้องใช้ตัวพิมพ์เล็กอย่างน้อยหนึ่งตัว และตัวเลข และคุณต้องมีความยาวขั้นต่ำ 10 ตัวอักษร',
    phone: 'โปรดระบุรหัสประเทศของโทรศัพท์ของคุณตัวอย่างเช่น: +66',
    username:
      'ชื่อผู้ใช้ของคุณถือเป็นข้อมูลสาธารณะและแชร์กับผู้ใช้รายอื่นตามความจำเป็น ดังนั้นเราขอแนะนำให้คุณอย่าใช้ข้อมูลส่วนบุคคลในชื่อผู้ใช้ของคุณ',
    public_description_normal:
      'ของคุณ <0><0/></0> ได้รับการบันทึกแล้วและถือว่าเป็นส่วนตัวโดยค่าเริ่มต้น ซึ่งหมายความว่ามีเพียงคุณเท่านั้นที่เห็นเนื้อหานี้ หากต้องการเผยแพร่เนื้อหานี้คุณสามารถเลือกหนึ่งในตัวเลือกด้านล่างนี้ การเผยแพร่สู่สาธารณะหมายความผู้ใช้งานทุกคนในองค์กรที่คุณเลือกสามารถมองเห็นได้ คุณยังสามารถเลือกเฉพาะเจาะจงบัญชีผู้ใช้งาน โดยการระบุที่อยู่อีเมลของบัญชีผู้ใช้งานที่ลงทะเบียนไว้ใน  Sharelook',
    public_description_admin:
      'ข้อมูลนี้ <0><0/></0> ได้รับการบันทึกแล้วและถือว่าเป็นส่วนตัวโดยค่าเริ่มต้น ซึ่งหมายความว่ามีเพียงคุณ (และผู้สร้างเนื้อหา) เท่านั้นที่สามารถดูเนื้อหานี้ได้. หากต้องการเผยแพร่เนื้อหานี้คุณสามารถเลือกหนึ่งในตัวเลือกด้านล่างนี้ การเผยแพร่หลักสูตรของคุณสู่สาธารณะหมายความว่าหลักสูตรนี้จะพร้อมใช้งานสำหรับผู้ใช้ทุกคนในแพลตฟอร์มรวมถึงผู้ที่อยู่นอกองค์กรของคุณ. การเผยแพร่ไปยังองค์กรหมายความว่าผู้ใช้ทุกคนภายในองค์กรจะสามารถมองเห็นได้. นอกจากนี้คุณยังสามารถเผยแพร่ไปยังกลุ่มได้อย่างน้องหนึ่งกรุ๊ป หรือหลายกรุ๊ป ซึ่งหมายความว่ามีเพียงผู้ใช้ในกรุ๊ปเหล่านั้นเท่านั้นที่จะเห็นได้ สุดท้ายนี้คุณมีตัวเลือกในการเผยแพร่ให้กับผู้ใช้เฉพาะภายในและภายนอกองค์กรของคุณโดยใช้ที่อยู่อีเมลของบัญชี Sharelook'
  },

  labels: {
    add: 'เพิ่ม',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'ตัวเลือกของคำตอบ',
    answers: 'คำตอบ',
    back_to_quiz: 'กลับสู่หน้ารายการชุดแบบสอบถาม',
    back_to_question: 'กลับสู่หน้ารายการชุดคำถาม',
    chat: 'บทสนทนา',
    chat_available: 'ไม่สามารถใช้บทสนทนาในวีดีโอถ่ายทอดสดนี้',
    chat_report: 'รายงานบทสนทนา',
    choice_single: 'สามารถเลือกคำตอบได้ข้อเดียวเท่านั้น',
    choice_multiple: 'สามารถเลือกคำตอบได้หลายข้อ',
    choice_free: '"ฟรี" ทางเลือก',
    choice_sorting: '"การเรียงลำดับ" ตัวเลือก',
    choice_matrix: '"การจับวางเรียงลำดับ" ตัวเลือก',
    clone_lesson_permission: 'สร้างสำเนาสิทธิ์การอนุญาติ',
    code: 'รหัส',
    correct: 'ถูกต้อง',
    created: 'วันที่สร้าง',
    clone_modal: 'สร้างสำเนาคอร์สเรียน',
    cloning_course: 'กำลังสร้างสำเนาคอร์สเรียน',
    cloning: 'กำลังสร้างสำเนา',
    cloning_course_desc: ' กรุณารอสักครู่ ขั้นตอนนี้อาจใช้เวลาเล็กน้อย',
    cloning_success: 'คอร์สเรียน "<0/>"สร้างสำเนาสำเร็จแล้ว',
    description: 'รายละเอียด',
    disclaimer: 'ขอสงวนสิทธิ์',
    drop_file: 'วางไฟล์ที่นี่',
    duration: 'ระยะเวลา',
    edit: 'แก้ไข',
    email: 'อีเมล',
    event: 'อีเว้นท์',
    event_all: 'อีเว้นท์ของเขาทั้งหมด',
    event_date: 'วันเวลาท้องถิ่นของวีดีโอถ่ายทอดสด',
    event_this: 'อีเว้นท์นี้',
    expire: 'หมดอายุเมื่อ',
    expiry_date: 'วันที่หมดอายุ',
    forgot: 'ลืมรหัสผ่าน?',
    group: 'กรุ๊ป',
    groups_list: 'รายชื่อกรุ๊ป',
    host: 'ผู้ทำการถ่ายทอดสด',
    id_annotation: 'รหัสป๊อปอัพ',
    id_quiz: 'รหัสคำถาม',
    incorrect: 'ไม่ถูกต้อง',
    interests: 'ความสนใจ',
    invited: 'รับเชิญ',
    live_chat: 'บทสนทนาพูดคุยในวีดีโอถ่ายทอดสด',
    live_stream_limit: 'นาทีการถ่ายทอดสด',
    contact_text: 'หากต้องการเปลี่ยนขีดจำกัด การถ่ายทอดสดรายเดือนโปรดติดต่อ',
    contact_admin:
      '<0>หากคุณต้องการเปลี่ยนแปลงขีดจำกัด การถ่ายทอดสดรายเดือนโปรดติดต่อ</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'เวลาการทำวีดีโอถ่ายทอดสดของคุณที่เหลืออยู่: <0>{{ limit }}</0> นาที <1/><2/> <3>หากคุณต้องการเปลี่ยนแปลงขีดจำกัด การถ่ายทอดสดรายเดือนโปรดติดต่อ</3> <4>admin@sharelook.com</4>',
    location: 'สถานที่',
    lessons: 'บทเรียน',
    location_broadcast: 'ตำแหน่งเซิร์ฟเวอร์ของผู้ทำการถ่ายทอดสด',
    location_broadcast_subtitle:
      'เพิ่มสถานที่ที่ใกล้ที่สุดกับตำแหน่งที่คุณจะทำการถ่ายทอดสดเพื่อลดความล่าช้าของภาพและเสียง',
    media_manager: 'การจัดการรูปภาพ',
    minutes: 'นาที',
    name: 'ชื่อ',
    online_quiz: 'คำถามออนไลน์',
    organiser: 'ผู้แต่ง',
    organization: 'องค์กร',
    overall_emotion: 'ประสบการณ์โดยรวม:',
    organizations_list: 'รายชื่อองค์กร',
    password: 'รหัสผ่าน',
    participants: 'ผู้เข้าร่วม',
    picture: 'รูปภาพ (16:9)',
    phone: 'โทรศัพท์มือถือ',
    photo: 'รูปถ่าย',
    poll: 'แบบสำรวจความคิดเห็น',
    position: 'ตำแหน่ง',
    processing: 'กำลังประมวลผล',
    privacy_settings: 'ตั้งค่าความเป็นส่วนตัว',
    question: 'คำถาม',
    quiz_create: 'สร้างชุดคำถาม',
    quiz_name: 'ชื่อคำถาม',
    quiz_update: 'อัพเดทชุดคำถาม',
    select_organization: 'เลือกองค์กร',
    settings: 'การตั้งค่า',
    show: 'แสดง',
    show_graph: 'แสดงผลในรูปแบบกราฟ',
    signin: 'เข้าสู่ระบบ',
    signup: 'สมัครการใช้งาน',
    sort_by: 'เรียงลำดับจาก',
    start_date: 'เริ่มจากวันที่',
    tags: 'Tags',
    terms: 'ฉันยอมรับ<1>ในข้อกำหนดและเงื่อนไข</1>.',
    title: 'ชื่อเรื่อง',
    topics: 'หัวข้อ',
    topic: 'หัวข้อ',
    total_comments: 'คอมเม้นต์ทั้งหมด',
    username: 'ชื่อผู้ใช้',
    users_list: 'รายชื่อผู้ใช้งาน',
    users_emails: 'ใส่อีเมลผู้ใช้งานเฉพาะเจาะจง',
    description_specifiction_email:
      'กรุณาใส่หนึ่งอีเมลต่อหนึ่งบรรทัดเพื่อทำการแชร์สำหรับผู้ใช้งานหลายคน',
    message_specific_email: ' กรุณาใส่อีเมลผู้ใช้งานที่เฉพาะเจาะจง',
    viewers: 'ผู้ชม',
    edit_course: 'แก้ไข',
    edit_assessment: 'แก้ไข',
    edit_event: 'แก้ไข',
    delete_course: 'ลบ',
    delete_event: 'ลบ',
    delete_assessment: 'ลบ',
    view_course: 'เปิดดู',
    view_event: 'เปิดดู',
    view_assessment: 'เปิดดู',
    date_event: 'วันที่วีดีโอถ่ายทอดสด',
    date_assessment: 'วันที่การประเมินผลแบบวีดีโอถ่ายทอดสด',
    clone_of: 'สร้างสำเนา',
    clone_course:
      'สร้างสำเนาคอร์สเรียนนี้รวมถึงเก็บข้อมูลทุกบทเรียนไว้แบบดั้งเดิมเพื่อทำการแก้ไขและปรับเปลี่ยนได้',
    make: 'ทำ',
    available_to: 'ผู้ใช้งานภายในองค์กร Sharelook สามารถใช้ได้',
    uploaded_by: 'อัพโหลดจาก: ',
    course: 'บทเรียน',
    assessment: 'การประเมินผลแบบวีดีโอถ่ายทอดสด',
    user_not_exist: 'ไม่พบบัญชีผู้ใช้นี้ คุณต้องการส่งคำเชิญหรือไม่',
    check_user: 'แจ้งให้ทราบ',
    user_not_exist_in_org:
      'ไม่พบบัญชีผู้ใช้นี้ในองค์กรนี้คุณต้องการส่งคำเชิญหรือไม่',
    title_modal_stream: 'เปลี่ยนจำนวนลิมิตการวีดีโอถ่ายทอดสดขององค์กร',
    des_warning_stream: 'คุณกำลังจะทำการเปลี่ยนแปลง',
    monthly_stream: 'ลิมิตต่อเดือนของการทำวีดีโอถ่ายทอดสด',
    min_per_month: 'นาที/เดือน',
    broadcast_label: 'ฉันต้องการจะทำ:',
    hosts_emails: `กรุณาใส่อีเมลของผู้ที่จะทำการถ่ายทอดสด`,
    attendee_emails: `กรุณาใส่อีเมลผู้เข้าร่วม`,
    description_host_specifiction_email:
      'กรุณาใส่หนึ่งอีเมลต่อหนึ่งบรรทัด',
    presenter_label: 'ผู้นำเสนอ',
    presenter_label_conference: 'จำนวนคน',
    event_privacy: 'โหมดการประชุม'
  },

  broadcastOptions: {
    stream_from_phone: 'ไลฟ์บรอดแคสต์จากมือถือ',
    other_webrtc: 'สัมมนาออนไลน์จากคอมพิวเตอร์',
    multihost: 'สัมมนาออนไลน์แบบหลายคนจากคอมพิวเตอร์',
    peer2peer: ' รายการการฝึกสอน',
    conference: 'การประชุมแบบวีดีโอถ่ายทอดสด'
  },

  lessoncreate: {
    title: 'เพิ่มรายละเอียดบทเรียน',
    subtitle:
      'ตั้งชื่อบทเรียนของคุณและบอกผู้เรียนว่าเขาจะได้อะไรจากบทเรียนนี้บ้าง',
    input_label_title: 'ชื่อบทเรียน',
    input_label_topics: 'หัวเรื่องบทเรียน',
    input_label_description: 'รายละเอียดของบทเรียน',
    delete_warning: 'คุณแน่ใจหรือว่าต้องการลบหน้านี้'
  },

  lessonoverview: {
    title: 'เพิ่มบทเรียน',
    subtitle: 'เพิ่มบทเรียนที่มีอยู่แล้วหรือสร้างบทเรียนใหม่',
    new_lesson: 'สร้างบทเรียนใหม่',
    new_lesson_sub: 'สร้างบทเรียนใหม่ตั้งแต่เริ่มต้น',
    existing_lesson: 'เลือกจากบทเรียนที่มีอยู่แล้ว',
    existing_lesson_sub:
      'เชื่อมโยงไปยังบทเรียนที่มีอยู่แล้ว, การเปลี่ยนแปลงบทเรียนนี้จะทำให้บทเรียนนี้ที่อยู่ในคอร์สเรียนอื่นๆ เปลี่ยนแปลงไปด้วย ',
    clone_lesson: 'สร้างสำเนาจากบทเรียนที่มีอยู่แล้ว',
    clone_lesson_sub:
      'ทำการคัดลอกแบบเฉพาะเจาะจง การเปลี่ยนแปลงบทเรียนนี้จะไม่ส่งผลใด ๆ ต่อบทเรียนต้นฉบับ',
    clone_lesson_modal_sub:
      'โปรดคลิกปุ่มโคลนใต้บทเรียนที่คุณต้องการเพิ่มลงคอร์สเรียนของคุณ'
  },

  management: {
    groups_title: 'จักการกรุ๊ป',
    delete_warning: 'คุณแน่ใจหรือ?',
    organizations_title: 'องค์กรของฉัน',
    organizations_subtitle: ' เพิ่มองค์กรในรายการของคุณ',
    users_title: 'จัดการผู้ใช้งาน',
    users_position: 'ผู้จัดการบัญชีอาวุโส',
    user_not_found: 'ไม่พบบัญชีผู้ใช้งานนี้',
    select_org: ' กรุณาเลือกองค์กรที่คุณต้องการจะจัดการผู้ใช้งาน'
  },

  audio: {
    modal_title: 'ใส่ไฟล์เสียง',
    list_view: 'รายชื่อคนดู',
    create_audio_modal_title: 'สร้างไฟล์เสียง',
    edit_audio_modal_title: 'แก้ไขไฟล์เสียง',
    public_audio_not_found: 'ไม่พบไฟล์เสียง',
    private_audio_not_found: 'คุณยังไม่ได้อัพโหลดไฟล์เสียง',
    are_you_sure_to_delete: 'คุณแน่ใจหรือว่าต้องการลบ',
    type_something: 'ลองพิมพ์อะไรสักอย่าง',
    select_voice: 'เลือก',
    file_name: 'ชื่อไฟล์',
    description: 'รายละเอียด',
    topic: 'หัวข้อ',
    key_words_tag: 'คีย์เวิร์ด Tag',
    mp3_audio: 'ไฟล์เสียง mp3',
    created: 'สร้างแล้ว',
    duration: 'ระยะเวลา',
    close: 'ปิด'
  },

  image: {
    modal_title: 'ใส่รูปภาพ',
    image: 'รูปภาพ',
    pixel: 'พิกเซล',
    dimension: 'ขนาดกว้างยาว',
    public_image_not_found: 'ไม่พบรูปภาพ',
    private_image_not_found: 'คุณยังไม่ได้อัพโหลดรูปภาพ'
  },

  annotation: {
    modal_title: 'ป๊อปอัพ'
  },

  text: {
    modal_title: 'เครื่องมือการแก้ไขข้อความ'
  },

  video: {
    modal_title: 'ใส่ไฟล์วีดีโอ',
    image: 'ไฟล์วีดีโอ',
    mp4_video: 'ไฟล์วีดีโอ mp4',
    public_video_not_found: 'ไม่พบไฟล์วีดีโอ',
    private_video_not_found: 'คุณยังไม่ได้อัพโหลดไฟล์วีดีโอ'
  },

  media: {
    title: 'คลังรูปภาพ',
    subtitle: 'คลังไฟล์ของคุณ',
    modal_title: 'อัพโหลดไฟล์ภาพ',
    delete_warning: 'ยืนยันการลบ',
    delete_message:
      'หากคุณทำการสื่อในคลังรูปภาพ มันยังคงปรากฏในหน้าที่มีการใช้งาน',
    dropzone_text: 'หรือลากแล้ววาง',
    delete_success: 'ไฟล์ภาพถูกลบเรียบร้อยแล้ว',
    upload_file: 'อัพโหลดไฟล์',
    drag_drop: 'หรือลากแล้ววาง',
    import_file: 'ดึงไฟล์จากคอมพิวเตอร์ของคุณ',
    no_media: 'คุณยังไม่ได้อัพโหลดไฟล์',
    media_type: 'ประเภทไฟล์สื่อ',
    video: 'วีดีโอ',
    image: 'รูปภาพ',
    audio: 'เสียง',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'ไม่พบไฟล์สื่อ',
    of: 'จาก',
    disclaimer: `ฉันรับประกันว่าสื่อของฉันไม่:
     - ละเมิดสิทธิ์ของบุคคลที่สาม
     - มีเนื้อหาที่ผิดกฎหมายใด ๆ รวมถึงเนื้อหาที่หมิ่นประมาทลามกอนาจารลามกอนาจารรุนแรงหยาบคายดูถูกคุกคามหรือเลือกปฏิบัติแม้กระทั่งปลอมตัวด้วยเครื่องหมายดอกจัน
     - มีการโจมตีบุคคลอื่นเป็นการส่วนตัว
     - มีการแอบอ้างเป็นบุคคลอื่นบุคคลสาธารณะหรือคนดัง
     - มีข้อมูลส่วนบุคคลใด ๆ ของบุคคลใด ๆ โดยไม่ได้รับความยินยอมจากบุคคลดังกล่าวและไม่ละเมิดกฎข้อบังคับด้านการคุ้มครองข้อมูลในส่วนใดของโลก
     - มีการชักชวนทางการค้าหรือ“ สแปม” รูปแบบใด ๆ`,

    // newlyadded
    my_media: 'สื่อของฉัน',
    public_library: 'ห้องสมุดสาธารณะ',
    organization_library: 'ห้องสมุดองค์กร',
    upload_from_computer: 'อัปโหลดจากคอมพิวเตอร์',
    pexel_images: 'รูปภาพ Pexel',
    create: 'สร้าง',
    all: 'ทั้งหมด',
    male: 'ชาย',
    female: 'หญิง',
    processing_audio: 'การประมวลผลเสียง',
    create_annotation: 'สร้างคำอธิบายประกอบ',
    popup_over_lesson_text: 'คำอธิบายประกอบจะปรากฏขึ้นเหนือหน้าบทเรียนหลังจากคลิก',
    edit_detail: 'แก้ไขรายละเอียด',
    delete: 'ลบ',
    go_create_audio: 'ไปสร้างเสียง',
    show_more_details: 'แสดงรายละเอียดเพิ่มเติม',
    show_less_details: 'แสดงรายละเอียดน้อยลง',
    drop_files: 'วางไฟล์และตำแหน่งที่จะอัปโหลด',
    or: 'หรือ',
    import_files: 'นำเข้าไฟล์จากคอมพิวเตอร์'
  },

  navigation: {
    account: 'บัญชี',
    assessments: 'การประเมิน',
    dashboard: 'แดชบอร์ด',
    groups: 'การจัดการกรุ๊ป',
    logout: 'ออกจากระบบ',
    organisations: 'องค์กร',
    organizations_users: 'องค์กรและผู้ใช้งาน',
    reports: 'รายงาน',
    schedule: 'การตั้งเวลา',
    training: 'หลักสูตรการเรียน',
    users: 'ผู้ใช้งาน',
    workshop: 'การประชุมเชิงปฏิบัติการของฉัน',
    nowLive: 'ออกอากาศ'
  },

  onboarding: {
    step1_title: 'ขั้นตอนแรกบอกให้เราทราบเกี่ยวกับตัวคุณเล็กน้อย',
    step1_subtitle:
      'คุณชื่ออะไร คุณมาจากไหน และคุณทำงานอะไร',
    step2_title: 'ขั้นตอนที่สอง เลือกความสามารถหรือสิ่งที่คุณสนใจและต้องการจะปรับปรุงหรือเรียนรู้เพิ่มเติม',
    step2_subtitle: 'ถัดไปจากนั้น บอกสิ่งที่คุณต้องการทำความเข้าใจให้ดีขึ้น อาจเป็นสิ่งที่คุณยังไม่ได้เลือก หรือหลักสูตรใหม่ ๆ  หรืออะไรที่คุณชอบและสนในอยากจะเรียนรู้?'
  },

  pagebuilder: {
    title: 'สร้างบทเรียน',
    subtitle:
      'ถึงเวลาสร้างเนื้อหาเพื่อให้ผู้ชมของคุณได้เรียนรู้ คุณสามารถเพิ่มรูปภาพวิดีโอและอินโฟกราฟิก',
    select_layout: 'เลือกรูปแบบโครงร่าง',
    template1: 'หน้าเปล่า',
    template2: 'หัวเรื่อง และหัวเรื่องย่อ',
    template3: 'หัวเรื่องและข้อความ',
    template4: 'หัวเรื่อง สื่อภาพสื่อวีดีโอและข้อความ',
    template5: 'หัวเรื่องและสื่อภาพสื่อวีดีโอ',
    template6: 'หัวเรื่องและชุดคำถาม'
  },

  pageconstructor: {
    title: 'สร้างและสร้างสำเนาบทเรียน',
    subtitle:
      'ถึงเวลาสร้างเนื้อหาเพื่อให้ผู้ชมของคุณได้เรียนรู้ คุณสามารถเพิ่มรูปภาพวิดีโอและอินโฟกราฟิก'
  },

  passwordreset: {
    success_coded:
      'เราได้ส่งรหัสยืนยันทางอีเมลไปยังที่อยู่ที่คุณให้ไว้โปรดคัดลอกรหัสลงในฟิลด์ด้านล่างเพื่อตั้งรหัสผ่านใหม่',
    success_changed:
      'คุณตั้งรหัสผ่านใหม่สำเร็จแล้ว คุณสามารถลงชื่อเข้าใช้ได้เลย'
  },

  placeholders: {
    search: 'ค้นหา',
    answer: 'คำตอบ',
    chat: 'กรุณาพิมพ์ข้อความ',
    code: 'รหัส',
    criterion: 'เกณฑ์/บรรทัดฐาน',
    date_event: 'เลือกวันและเวลา',
    date_start: 'วันที่เริ่ม',
    date_expire: 'วันที่หมดอายุ',
    description: 'รายละเอียด',
    elements: 'จัดเรียงโดยองค์ประกอบ',
    email: 'อีเมล',
    feedback_correct: 'คำตอบถูกตอบ',
    feedback_incorrect: 'คำตอบไม่ถูกต้อง',
    host: 'ผู้ทำการถ่ายทอดสด',
    keywords: 'ค้นหาโดยคีย์เวิร์ด',
    lesson_description: 'คำอธิบายบทเรียน',
    location: 'สถานที่',
    minutes: 'จำนวนนาที',
    name: 'ชื่อ',
    organiser: 'ผู้สร้าง',
    organization: 'องค์กร',
    password: 'รหัสผ่าน',
    phone: 'โทรศัทพ์มือถือ',
    photo: 'รูปถ่าย',
    picture: 'รูปภาพ',
    point: 'คะแนน',
    position: 'ตำแหน่ง',
    question: 'คำถาม',
    quiz: 'ชื่อแบบสอบถาม',
    search_course: 'ค้นหาจากคอร์สเรียน',
    search_media: 'ค้นหารูปภาพและวีดีโอ',
    search_name: 'ค้นหาจากชื่อ',
    search_title: 'ค้นหาจากชื่อหัวเรื่อง',
    search_training: 'ค้นหาหลักสูตรการเรียน',
    settings: 'การตั้งค่า',
    tags: 'Tags',
    title: 'หัวเรื่อง',
    topics: 'หัวข้อ',
    username: 'บัญชีผู้ใช้งาน',
    keyword: 'คีย์เวิร์ด',
    max_500_characters: 'เยอะสุดไม่กิน 500 ตัวอักษร',
    no_description: 'ไฟล์นี้ไม่มีรายละเอียด',
    no_keyword: 'ไฟล์นี้ไม่มีคีย์เวิร์ด',
    no_topics: 'ไฟล์นี้ยังไม่มีการตั้งหัวข้อ',
    feedback: 'ข้อความ',
    contact: 'คุณต้องการความช่วยเหลือใช่ใหม?'
  },

  publishsettings: {
    title: 'การตั้งค่าการเผยแพร่',
    event_subtitle:
      'เพิ่มการตั้งค่าในวีดีโอถ่ายทอดสดของคุณ เพื่อกำหนดว่าใครสามารถมองเห็นและเข้าร่วมได้',
    assessment_subtitile:
      'ตั้งชื่อการประเมินผลแบบวีดีโอถ่ายทอดสดของคุณและบอกผู้ชมของคุณว่าพวกเขาควรจะเรียนรู้อะไรจากมัน',
    course_subtitle:
      'เพิ่มการตั้งค่าคอร์สเรียนของคุณว่าใครสามารถเข้ามาดูหรือมีส่วนร่วมในคอร์สเรียนของคุณได้',
    disclaimer:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis',
    dates_validation_error: 'จำเป็นต้องใส่วันที่ของทั้งสองส่วน',
    emails_validation_error: 'รายชื่ออีเมลไม่ถูกต้อง',
    specific_email_validation_error: 'อนุญาตให้ใช้อีเมลเดียวเท่านั้น',
    i_agree_to_these: 'ฉันเห็นด้วยและยินยอมกับสิ่งเหล่านี้',
    terms_and_conditions: 'ข้อกำหนดและเงื่อนไข',
    PublicDescription:
      'บัญชีผู้ใช้งานทัวไป: (ตัวเลือกความเป็นส่วนตัวและสาธารณะ)ของคุณ [คอร์สเรียน|รายการ|การประเมินผลแบบวีดีโอถ่ายทอดสด] ได้รับการบันทึกและถือว่าเป็นส่วนตัวโดยค่าเริ่มต้น ซึ่งหมายความว่ามีเพียงคุณเท่านั้นที่เห็นเนื้อหานี้ หากต้องการเผยแพร่เนื้อหานี้คุณสามารถเลือกให้เป็นสาธารณะด้านล่าง ซึ่งหมายความว่าหลักสูตรนี้จะพร้อมใช้งานสำหรับผู้ใช้ทุกคนในแพลตฟอร์ม',
    OrganisationsDescription:
      'บัญชีผู้ใช้งานทั่วไปในองค์กร: (แทนที่จะใช้" "เสร็จสิ้น" "ให้ใช้" "เผยแพร่" และนำ ไปยังหน้าเผยแพร่เช่นเดียวกับผู้ใช้รายอื่น แต่ไม่มีตัวเลือกการเผยแพร่ใด ๆ ) [หลักสูตร | กิจกรรม | การประเมินผล] ของคุณได้รับการบันทึกและ เป็นส่วนตัว ซึ่งหมายความว่ามีเพียงคุณและแอดมินในองค์กรของคุณเท่านั้นที่สามารถมองเห็นได้  และเนื่องจากบัญชีของคุณเป็นเพียงบัญชีผู้ใช้งานทั่วไปไม่ใช่แอดมิน ดังนั้นคุณไม่สามารถเผยแพร่เนื้อหาของคุณภายในองค์กรของคุณด้วยตัวคุณเองได้ โปรดติดต่อผู้ดูแลระบบหรือผู้ที่เป็นแอดมิน และขอให้พวกเขาเผยแพร่เนื้อหาของคุณแบบสาธารณะไปยังทั้งองค์กรไปยังกลุ่มเฉพาะภายในองค์กรของคุณหรือให้กับผู้ใช้ที่ระบุ',
    OrganisationGroupsDescription:
      'บัญชีผู้ดูแลระบบขององค์กรหรือแอดมิน: (สำหรับเนื้อหาที่สร้างขึ้นภายในองค์กร: ส่วนตัวสาธารณะองค์กรกลุ่มผู้ใช้เฉพาะ): [คอร์สเรียน | รายการกิจกรรม | การประเมินผล] นี้ได้รับการบันทึกและถือว่าเป็นส่วนตัวโดยค่าเริ่มต้น ซึ่งหมายความว่ามีเพียงคุณ (และผู้สร้างเนื้อหา) เท่านั้นที่สามารถดูเนื้อหานี้ได้ หากต้องการเผยแพร่เนื้อหานี้คุณสามารถเลือกหนึ่งในตัวเลือกด้านล่างนี้ การเผยแพร่หลักสูตรของคุณสู่สาธารณะหมายความว่าหลักสูตรนี้จะพร้อมใช้งานสำหรับผู้ใช้ทุกคนในแพลตฟอร์มรวมถึงผู้ที่อยู่นอกองค์กรของคุณ การเผยแพร่ไปยังองค์กรหมายความว่าผู้ใช้ทุกคนภายในองค์กรจะสามารถมองเห็นได้ นอกจากนี้คุณยังสามารถเผยแพร่ไปยังกรุ๊ปได้อย่างน้อยหนึ่งกรุ๊ปหรือมากกว่า ซึ่งหมายความว่ามีเพียงผู้ใช้ในกรุ๊ปเหล่านั้นเท่านั้นที่จะเห็นได้ สุดท้ายนี้คุณมีตัวเลือกในการเผยแพร่ให้กับผู้ใช้เฉพาะภายในและภายนอกองค์กรของคุณโดยใช้ที่อยู่อีเมลของบัญชี Sharelook ',
    SpecificUsersDescription:
      'บัญชีผู้ใช้งานแบบชำระเงิน: (ความเป็นส่วนตัว สาธารณะและเฉพาะเจาะจง) [คอร์สเรียน | รายการกิจกรรม | การประเมินผล] ของคุณได้รับการบันทึกแล้วและถือว่าเป็นส่วนตัวตามค่าเริ่มต้น ซึ่งหมายความว่ามีเพียงคุณเท่านั้นที่เห็นเนื้อหานี้ หากต้องการเผยแพร่เนื้อหานี้คุณสามารถเลือกหนึ่งในตัวเลือกด้านล่างนี้ การเผยแพร่คอร์สเรียนของคุณสู่สาธารณะหมายความว่าคอร์สเรียนจะพร้อมใช้งานสำหรับผู้ใช้ทุกคนในแพลตฟอร์ม ตัวเลือกผู้ใช้เฉพาะจะช่วยให้คุณสามารถแบ่งปันคอร์สเรียนของคุณกับผู้ใช้งานแบบเฉพาะเจาะจง โดยใช้ที่อยู่อีเมลที่พวกเขาใช้ลงทะเบียนหรือมีบัญชีผู้ใช้งานกับ Sharelook '
  },

  quiz: {
    quiz_empty: 'คุณยังไม่ได้สร้างชุดแบบสอบถาม',
    questions_empty: 'คุณยังไม่ได้สร้างคำถาม'
  },

  regions: {
    asia_pacific_australia: 'ออสเตเรีย',
    asia_pacific_india: 'อินเดีย',
    asia_pacific_japan: 'ญี่ปุ่น',
    asia_pacific_s_korea: 'เกาหลีใต้',
    asia_pacific_singapore: 'สิงคโปร์ ',
    asia_pacific_taiwan: 'ไต้หวัน',
    eu_belgium: 'เบลเยี่ยม',
    eu_germany: 'เยอรมัน',
    eu_ireland: 'ไอร์แลนด์',
    south_america_brazil: 'บราซิล',
    us_central_iowa: 'ไอโอวา',
    us_east_s_carolina: 'เซาท์แคโรไลนา',
    us_east_virginia: 'เวอร์จิเนีย',
    us_west_california: 'แคลิฟอร์เนีย',
    us_west_oregon: 'ออริกอน'
  },

  reports: {
    title: 'รายงาน',

    // newlyadded
    workshop_report: 'รายงานการประชุมเชิงปฏิบัติการ',
    user_report: 'รายงานผู้ใช้',
    organization_workshop: 'การประชุมเชิงปฏิบัติการขององค์กร',
    course: 'ภาพรวมของคอร์ส',
    live_event: 'ถ่ายทอดสด',
    workShop_graph: 'กราฟการประชุมเชิงปฏิบัติการ',
    organization_account: 'บัญชีองค์กร',
    all: 'ทั้งหมด',
    name: 'ชื่อ',
    id_number: 'เลขประจำตัว',
    email: 'อีเมล์',
    search_user_report: 'ค้นหารายงานผู้ใช้',
    participant: 'ผู้เข้าร่วม',
    participants: 'ผู้เข้าร่วม',
    host: 'เจ้าภาพ',
    username: 'ชื่อผู้ใช้',
    event: 'อีเว้นท์',
    quiz: 'แบบทดสอบ',
    assessment: 'การประเมิน',
    time: 'เวลา',
    no_recent_activity: 'ไม่มีกิจกรรมล่าสุด',
    workshops: 'เวิร์คช็อป',
    courses: 'หลักสูตร',
    live_events: 'เหตุการณ์สด',
    live_assessments: 'การประเมินสด',
    quizzes: 'แบบทดสอบ',
    overview: 'ภาพรวม',
    by: 'โดย',
    views: 'มุมมอง',
    status: 'สถานะ',
    poll: 'แบบสำรวจ',
    comment: 'แสดงความคิดเห็น',
    comments: 'ความคิดเห็น',
    no_comments: 'ไม่มีความคิดเห็น',
    no_polls: 'ไม่มีการสำรวจ',
    live_date: 'วันที่ถ่ายทอดสด',
    score: 'คะแนน',
    question: 'คำถาม',
    submit: 'ส่ง',
    recent_activity: 'กิจกรรมล่าสุด',
    ago: 'ที่ผ่านมา',
    no_data_found: 'ไม่พบข้อมูล',
    start_end_live: 'เริ่ม / สิ้นสุดการถ่ายทอดสด',
    join_leave_date: 'เข้าร่วม / ออกจากการถ่ายทอดสด',
    watched_time: 'เวลาในการรับชม',
    complete: 'เสร็จสมบูรณ์',
    in_complete: 'ในเสร็จสมบูรณ์',
    today: 'วันนี้',
    seven_days: '7 วัน',
    last_month: 'เดือนที่แล้ว',
    one_year: '1 ปี',
    all_time: 'ตลอดเวลา',
    report: 'รายงาน',
    from_date: 'จากวันที่',
    to_date: 'ถึงวันที่',
    all_workshop: 'การประชุมเชิงปฏิบัติการทั้งหมด',
    all_participants: 'ผู้เข้าร่วมทั้งหมด',
    live_assessment: 'การประเมินสด',
    users: 'ผู้ใช้',
    download: 'ดาวน์โหลด',
    recent: 'ล่าสุด',
    WorkShop: 'การประชุมเชิงปฏิบัติการ',
    Activity: 'กิจกรรม',
    created_date: 'สร้างเมื่อ',
    lessons: 'บทเรียน',
    lesson: 'บทเรียน',
    completed: 'บทเรียน',
    report_download: 'ดาวน์โหลดรายงาน',
    this_month: 'เดือนนี้',
    search_course: 'หลักสูตรการค้นหา',
    participants_graph: 'กราฟผู้เข้าร่วม',
    viewed: 'ดูแล้ว',
    enrolled: 'ลงทะเบียนแล้ว',
    description: 'คำอธิบาย',
    topic: 'หัวข้อ',
    analytic: 'วิเคราะห์',
    quiz_list: 'รายการคำถาม',
    select_one: 'เลือกหนึ่งอัน',
    group_status: 'สถานะกลุ่ม',
    duration_min: 'ระยะเวลา (นาที)',
    submit_poll: 'ส่งแบบสำรวจ',
    download_events: 'ดาวน์โหลดเหตุการณ์',
    search_event: 'ค้นหาเหตุการณ์',
    duration: 'ระยะเวลา',
    total_participants: 'ผู้เข้าร่วมทั้งหมด',
    message: 'ข้อความ',
    avg_message: 'ข้อความเฉลี่ย',
    per_message: 'เปอร์เซ็นต์ของข้อความ / เหตุการณ์',
  },

  signup: {
    success_step1:
      'เราได้ส่งรหัสยืนยันไปยังที่อยู่ที่คุณให้ไว้ทางอีเมล โปรดคัดลอกรหัสลงในฟิลด์ด้านล่างเพื่อยืนยันการลงทะเบียนของคุณ',
    success_step2: 'ขอบคุณ คุณลงทะเบียนเรียบร้อยแล้ว',
    privacy: `ฉันยอมรับกับ Sharelook <1> ข้อกำหนดและเงื่อนไข</1> และ <3> นโยบายความเป็นส่วนตัว</3>`
  },

  stream: {
    emotion_impressive: 'ประทับใจ',
    emotion_unimpressive: 'ไม่ประทับใจ',
    message_not_started: 'เร็วๆ นี้',
    message_running: 'วีดีโอถ่ายทอดสด',
    message_processing:
      ' เรากำลังดำเนินการบันทึกการถ่ายทอดสดของคุณ คุณสามารถย้อนกลับมาดูหรือนำกลับมาใช้งานต่อไป โปรดกลับมาตรวจสอบในภายหลังเพื่อดูวิดีโอและเพิ่มคะแนนและข้อเสนอแนะต่อไป '
  },

  tabs: {
    audience: 'ผู้ชม',
    course: 'ภาพรวมของคอร์ส',
    details: 'ข้อมูลวีดีโอถ่ายทอดสด',
    description: 'รายละเอียด',
    host: 'ผู้ทำการถ่ายทอดสด',
    lesson: 'ภาพรวมของบทเรียน',
    lessons: 'บทเรียน',
    overview: 'ภาพรวม',
    page: 'ตัวสร้างเพจ',
    publish: 'เผยแพร่',
    settings: 'ตั้งค่าการเผยแพร่',
    total_views: 'จำนวนผู้ชมทั้งหมด',
    live_participates: 'ผู้เข้าร่วมในวีดีโอถ่ายทอดสด',
    live_chats: 'บทสนทนาวีดีโอถ่ายทอดสด',
    live_quiz: 'แบบสอบถามวีดีโอถ่ายทอดสด',
    trainer_rating: 'การให้คะแนนผู้ฝึกสอน',
    trainer_times: 'เวลาของผู้ฝึกสอน',
    courses_quizzes: 'ชุดคำถามของคอร์ส',
    user_list: 'รายชื่อผู้ใช้',
    discussion: 'บทสนทนา',
    notes: 'บันทึกส่วนตัว'
  },

  topics: {
    SALES_TRAINING: 'Sales Training',
    NEGOTIATION_TRAINING: 'Negotiation Training',
    CROSS_CULTURAL_AWARENESS: 'Cross-Cultural Awareness',
    NETWORKING_SKILLS: 'Networking Skills',
    SOFTWARE_ARCHITECTURE: 'Software Architecture',
    PROJECT_MANAGEMENT: 'Project Management',
    DIGITAL_TRANSFORMATION: 'Digital Transformation',
    IT_CONSULTING: 'IT Consulting',
    MANAGEMENT_CONSULTING: 'Management Consulting',
    HR_CONSULTING: 'HR Consulting',
    INTERNET_OF_THINGS: 'Internet of Things (IoT)',
    CYBERSECURITY: 'Cybersecurity',
    PRIVACY_AND_GDRP: 'Privacy and GDPR'
  },

  training: {
    title: 'หลักสูตรการเรียน',
    title_assessment: 'การประเมินผลแบบวีดีโอถ่ายทอดสด',
    subtitle: ' คอร์สและวีดีโอถ่ายทอดสด',
    enrolled_title: 'ลงชื่อเรียนคอร์สและวีดีโอถ่ายทอดสด',
    enrolled_subtitle: ' คอร์สเรียนและวีดีโอถ่ายทอดสดที่คุณลงชื่อเข้าร่วม',
    enrolled_message:
      'ตอนนี้คุณยังไม่ได้ลงชื่อเข้าร่วมในคอร์สเรียนและวีดีโอถ่ายทอดสด',
    past_live_event_title: ' วีดีโอถ่ายทอดสดที่ผ่านไปแล้ว',
    past_live_event_subTitle: 'เสร็จสิ้นวีดีโอถ่ายทอดสด',
    past_live_event: 'ตอนนี้ยังไม่มีวีดีโอถ่ายทอดสดที่ผ่านไปแล้ว',
    recomended_title: 'คอร์สเรียนและวีดีโอถ่ายทอดสดที่แนะนำ',
    now_live_event_title: 'ถ่ายทอดสดอยู่ขณะนี้',
    now_live_event_subTitle: 'รายการที่คุณจะทำการถ่ายทอดสดจะเกิดขึ้นเร็วๆ นี้',
    now_live_event: 'ตอนนี้ยังไม่มีรายการวีดีโอถ่ายทอดสด',
    webinar_event_title: 'ช่องทางการสัมนาทางเว็บ',
    webinar_event_subTitle: 'จบการสัมนาทางเว็บออนไลน์',
    webinar_event: 'ตอนนี้ยังไม่มีการสัมนาทางเว็บ',
    p2p_event_title: 'การฝึกสอน',
    p2p_event_subTitle: 'เสร็จสิ้นรายการการฝึกสอน',
    p2p_event: 'ตอนนี้ยังไม่มีรายการการฝึกสอน',

    now_live_assessment_title: 'ถ่ายทอดสดอยู่ขณะนี้',
    now_live_assessment_subTitle:
      ' การประเมินผลแบบวีดีโอถ่ายทอดสดที่คุณเป็นผู้ดำเนินรายการหรือมีส่วนร่วมกำลังจะเกิดขึ้นเร็วๆ นี้',
    now_live_assessment_message: 'ตอนนี้ยังไม่มีการประเมินผลแบบวีดีโอถ่ายทอดสด',

    upcoming_assessment_title: 'การประเมินผลแบบวีดีโอถ่ายทอดสดที่กำลังจะเกิดขึ้น',
    upcoming_assessment_subtitle: 'การประเมินผลแบบวีดีโอถ่ายทอดสดที่กำลังจะเกิดขึ้น',
    upcoming_assessment_message:
      'ตอนนี้ยังไม่มีการประเมินผลแบบวีดีโอถ่ายทอดสดที่กำลังจะเกิดขึ้น',
    past_live_assessment_title: 'การประเมินผลแบบวีดีโอถ่ายทอดสดที่ผ่านไปแล้ว',
    past_live_assessment_subTitle: 'เสร็จสิ้นการประเมินผลแบบวีดีโอนถ่ายทอดสด',
    past_live_assessment_message:
      'ตอนนี้ยังไม่มีการประเมินผลแบบวีดีโอถ่ายทอดสดที่ผ่านไปแล้ว',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'เราได้ดูแลจัดการคอร์สเรียนและวีดีโอนถ่ายทอดสดโดยอ้างอิงจากข้อมูลของคุณ <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: ' ค้นหาหลักสูตรการเรียน',
    search_assessment: 'ค้นหาการประเมินผลแบบวีดีโอถ่ายทอดสด',
    recomended_message: 'ขณะนี้ยังไม่มีคอร์สเรียนและกิจกรรมแนะนำ'
  },

  warnings: {
    delete: 'คุณแน่ใจหรือไม่?'
  },

  workshop: {
    title: 'การประชุมเชิงปฏิบัติการของฉัน',
    subtitle: 'สร้างคอร์สเรียนหรือถ่ายทอดสดด้วยตัวของคุณเอง',
    new_course: ' สร้างคอร์สเรียนใหม่',
    new_event: 'สร้างวีดีโอถ่ายทอดสดใหม่',
    new_assessment: 'สร้างกระประเมินผลแบบวีดีโอถ่ายทอดสดใหม่',
    courses_title: 'สร้างคอร์สเรียนและการถ่ายทอดสด',
    courses_subtitle: 'แก้ไขและเผยแพร่คอร์สเรียนที่คุณสร้างขึ้นและวางแผนการถ่ายทอดสด',
    tags_course: 'คอร์สเรียน',
    tags_live: 'การถ่ายทอดสด',
    tags_assessment: ' การประเมินผลแบบวีดีโอถ่ายทอดสด'
  },

  help_center: {
    sidebar: {
      title: 'เราสามารถช่วยคุณได้อย่างไร?',
      back_to: 'แดชบอร์ด'
    },
    menu: {
      help_center: 'ศูนย์ช่วยเหลือ',
      whats_new: 'มีข่าวอะไรใหม่ ๆ ใหม',
      feedback: 'ความคิดเห็น',
      feedback_title: 'ส่งความคิดเห็นให้ sharelook',
      terms_and_conditions: 'ข้อตกลงและเงื่อนไข',
      privacy_policy: 'นโยบายความเป็นส่วนตัว',
      contact_us: 'ติดต่อเรา'
    },
    get_started: {
      title: 'เริ่มการใช้งานกับ sharelook',
      description: {
        main: 'เราได้รวบรวมวิดีโอสาธิตการใช้งานต่าง ๆ ไว้ในตัวสร้างคอร์สเรียนเพื่อใช้งานง่ายขึ้น',
        tagline:
          'ด้วยระบบถ่ายทอดสดที่ได้รับการจดสิทธิบัตรของ ShareLook คุณสามารถสร้าง และมีส่วนร่วมการเรียนรู้ และเพิ่มเติมการเรียนรู้ของคุณรวมถึงการแบ่งปันความรู้ได้สูงสุด'
      }
    },
    whats_new: {
      title: 'เริ่มการใช้งานกับ sharelook',
      description: {
        main:
          'คุณรู้ไหมว่าการสร้างบทเรียนหรือหลักสูตรการเรียนรู้รูปแบบการเล่าเรื่อง สามารถสร้างได้ในเวลาอันสั้นและไม่แพงเลย คุณควรสร้างหลักสูตรหรือความสามารถของคุณลงใน ShareLook เพื่อให้มีคนติดตามสนใจ ติดต่อเราสำหรับข้อมูลเพิ่มเติม',
        tagline: ''
      }
    },
    create_workshop: 'Hวิธีสร้างเวิร์กชอป',
    create_course: ' สร้างคอร์สเรียนอย่างไร',
    create_user: 'สร้างบัญชีผู้ใช้งานอย่างไร',
    create_group: 'สร้างกรุ๊ปอย่างไร',
    create_webinar: ' สร้างการสัมมนาออนไลน์อย่างไร',
    create_live_event: 'สร้างการถ่ายทอดสดอย่างไร',
    create_live_assessment: ' สร้างการประเมินผลแบบวีดีโอถ่ายทอดสดอย่างไร',
    create_live_on_mobile: 'สร้างการถ่ายทอดสดด้วยโทรศัพท์มือถือ',
    personalize_profile: 'ปรับแต่งแก้ไขโปรโฟล์',
    manage_group: 'จัดการกรุ๊ป',
    report: 'รายงาน',
    add_annotations: 'เพิ่มป๊อบอัพอย่างไร',
    add_audio: 'เพิ่มหรือใส่เสียงอย่างไร',
    add_header_and_footer: 'เพิ่มหัวกระดาษและท้ายกระดาษอย่างไร',
    add_image: 'เพิ่มรูปภาพอย่างไร',
    add_quiz_content: 'เพิ่มชุดแบบสอบถามอย่างไร',
    add_text_content: 'เพิ่มข้อความตัวอักษรอย่างไร',
    add_user: 'เพิ่มบัญชีผู้ใช้งานอย่างไร',
    add_video: ' เพิ่มวีดีโออย่างไร',
    clone_course: 'สร้างสำเนาคอร์สเรียนอย่างไร',
    find_live_broadcast: 'ค้นหารายการการถ่ายทอดสดอย่างไร',
    contact_us: {
      title: 'ติดต่อเรา',
      subject_placeholder: 'ใส่หัวเรื่อง *',
      content_placeholder: 'ใส่ข้อความ*',
      subject_required: '*จำเป็นต้องใส่หัวเรื่อง',
      content_required: '*จำเป็นต้องใส่ข้อความ',
      submit: 'ส่ง',
      cancel: 'ยกเลิก',
      sent: 'ส่งแล้ว'
    },
    feedback: {
      title: 'ส่งความคิดเห็นไปยัง sharelook',
      attach_title: 'แนบไฟล์',
      choose: 'เลือกไฟล์',
      detail: ' ไฟล์นี้จะถูกแบ่งปันกับทีมซัพพอร์ต',
      content_placeholder: 'ใส่ข้อความ*',
      content_required: '*จำเป็นต้องใส่ข้อความ',
      submit: 'ส่ง',
      cancel: 'ยกเลิก',
      sent: 'ส่งแล้ว'
    }
  },
  discussion: {
    join_discussion: 'ร่วมพูดคุยในบทสนทนา'
  },
  notes: {
    title: 'บันทึกส่วนตัวของฉัน',
    add_note: 'เพิ่มบันทึกของฉัน'
  }
}
